import Chart from './chart';

export default Chart;



// WEBPACK FOOTER //
// ./src/components/cards/chart/index.js